<template>
  <div class="pt16">
    <ul class="grid-view">
      <li
        v-for="index in length"
        :key="index"
        class="d-flex flex-wrap cursor-pointer align-items-center shimmer-container rounded grid-menu-img-wrap"
      ></li>
    </ul>
  </div>
</template>
<script>
export default {
  name: "ProductCategoryGridShimmer",
  data() {
    return {
      length: 9,
    };
  },
};
</script>
